module.exports = __webpack_public_path__ + "img/ezCrs-ngang-trang.91d2d42d.png";